import { render, staticRenderFns } from "./InformationEdunetin.vue?vue&type=template&id=47494402&scoped=true"
import script from "./InformationEdunetin.vue?vue&type=script&lang=ts"
export * from "./InformationEdunetin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47494402",
  null
  
)

export default component.exports